<template>
  <div>
    <div class="pagination" v-if="getItemsLength(items) > perpage">
      <div class="prev" @click="prevPage()" :class="{hidden:((page) < 2)}">&lt;</div>
      <div class="page" v-for="i in getNumberPages()" @click="setPage(i)" :class="{'active':((page)==i)}">{{i}}</div>
      <div class="next" @click="nextPage()" :class="{hidden:((page)+1 > getNumberPages())}">&gt;</div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'items', 'perpage', 'page' ],
  methods: {
    setPage(index){
      this.$emit('updated', (index) )
    },
    prevPage(){
      this.$emit('updated', (this._props.page-1) )
    },
    nextPage(){
      this.$emit('updated', (this._props.page+1) )
    },
    getItemsLength(items){
      if( typeof items === 'object' ) items = Object.keys(items).map((k) => items[k])
      return items.length
    },
    getPerPage(){
      if( !this._props.perpage ) return 10
      return parseInt(this._props.perpage)
    },
    getNumberPages() {
      var perpage = this.getItemsLength(this.items) / this.getPerPage()
      perpage = parseInt(perpage)
      if( perpage < 1 ) perpage = 1
      return perpage
    },
  },
}
</script>

<style lang="scss">
	@import '../styling/global_vars';

	.pagination {
	  text-align: center;
    margin-top: 1em;

	  .next, .prev, .page {
	    background-color: $skin1_color3;
      height: 2em;
      width: 2em;
      //border-radius: 100%;
      text-align: center;
      line-height: 2em;
      display: inline-block;
      margin: 0 0.2em;
      transition: all 200ms $easeOutCubic;
      cursor: pointer;
      &:hover { opacity: 0.7; }
      &:active { opacity: 0.4; }
      &.active {
        background-color: $skin1_color1;
        color: $skin1_color2;
      }
      &.hidden {
        //visibility: hidden;
        pointer-events: none;
        opacity: 0.3;
      }
	  }
	}

</style>



// WEBPACK FOOTER //
// Pagination.vue?140d7d4d